
/*
 * BloominBag Gift Atelier 2027
 * Corporate Quote — Product & Gift Set Autofill
 * TR / EN compatible
 */

(function () {
  'use strict';

  // Prevent duplicate listeners if the asset runs again.
  if (window.BB27QuoteInitialized) return;
  window.BB27QuoteInitialized = true;

  const inputSelector =
    'input[name="contact[Ürün veya set]"]';

  function getQuoteElements() {
    const section = document.querySelector('.bb27-quote');

    if (!section) return null;

    const input = section.querySelector(inputSelector);

    if (!input) return null;

    return { section, input };
  }

  function setProduct(input, productName) {
    input.value = productName;

    input.dispatchEvent(
      new Event('input', { bubbles: true })
    );
  }

  function fillFromURL() {
    const elements = getQuoteElements();

    if (!elements) return;

    const params = new URLSearchParams(
      window.location.search
    );

    const productName = params.get('bb_product');

    // Do not overwrite a product already selected.
    if (productName && !elements.input.value) {
      setProduct(elements.input, productName);
    }
  }

  function handleQuoteClick(event) {
    const link = event.target.closest(
      '[data-bb27-quote]'
    );

    if (!link) return;

    const productName = link.getAttribute(
      'data-bb27-quote'
    );

    const elements = getQuoteElements();

    if (!elements || !productName) return;

    event.preventDefault();

    setProduct(elements.input, productName);

    const reduceMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    elements.section.scrollIntoView({
      behavior: reduceMotion ? 'auto' : 'smooth',
      block: 'start'
    });

    elements.input.focus({
      preventScroll: true
    });
  }

  // Register the click listener only once.
  document.addEventListener('click', handleQuoteClick);

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      fillFromURL
    );
  } else {
    fillFromURL();
  }

  // Shopify Theme Editor compatibility.
  document.addEventListener(
    'shopify:section:load',
    fillFromURL
  );
})();
